export const formatReviewSku = sku => sku?.replaceAll('/', '_');
